import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import { AddonAlternateRow, BlackCell, BlueCell, BrightYellowCellBorder, CellNoBorder, DarkGreyCellBorder, GreenCell, LightGreyCell, LightYellowCellBorder, OrangeCell, QtyInput, StyledTableRow, TableInput, TableSelect, YellowCell } from '../components/Page/TableStyles';
import {getFormData, setData} from '../store/slices/formDataSlice';
import {formatMoney} from '../helpers';

export const AddonsPath = "/addons"

export default function Addons(props) {
    const dispatch = useDispatch();

    const formData = useSelector(getFormData);

    const updateAddons = (sku, qty) => {
        //addons should be an array in formdata, use a object of sku and qty
        //if an event comes in with 0 qty remove from addons
        //if an event comes in with more than 0 qty add to addons
        var newArr = JSON.parse(JSON.stringify(formData.chosenAddons));
        var foundIndex = -1;
        newArr.some((v, k) => {
            if (v.SKU == sku) {
                foundIndex = k
                return true
            }
        })
        if (foundIndex == -1) {
            //add this to the array
            newArr.push({
                SKU: sku,
                Qty: qty
            })
        } else {
            //update the array
            newArr[foundIndex].Qty = qty;
        }
        updateFormData('chosenAddons', newArr);
    }

    const updateExtraAddon = (name, prop, value) => {
        var newArr = JSON.parse(JSON.stringify(formData[name]));
        newArr[prop] = value;
        updateFormData(name, newArr)
    }

    const updateFormData = (key, value) => {
        dispatch(setData({
            prop: key,
            value: value
        }));
    }

    return (
        <div style={{padding: '10px 30px', width: '100%', height: '100%'}}>
            <Table size="small">
                <TableBody>
                    <StyledTableRow>
                        <YellowCell>PD-ID</YellowCell>
                        <YellowCell style={{width: "50%"}}>Addon Description</YellowCell>
                        <YellowCell>SKU</YellowCell>
                        <YellowCell>Price</YellowCell>
                        <YellowCell>Qty</YellowCell>
                        <YellowCell style={{width: "60px"}}>Sub Total</YellowCell>
                    </StyledTableRow>
                    {
                        formData.allProducts.loaded && formData.allProducts.data.Addons.map(a => {
                            //check if this is in some selected addons
                            var exists = formData.chosenAddons.find(ea => {
                                return a.PipedriveID == ea.SKU;
                            });
                            var total = exists ? formatMoney(exists.Qty * a.Price) : '-';
                            //total for arrays is a special multiplier, they get 2 for free
                            if (exists && a.SKU === "Arrays") {
                                total = exists && exists.Qty <= 2 ? '-' : formatMoney((exists.Qty - 2) * a.Price);
                            }
                            return (
                                <AddonAlternateRow key={'addon-row-' + a.SKU}>
                                    <BlackCell>{a.PipedriveID}</BlackCell>
                                    <TableCell>{a.Description}</TableCell>
                                    <TableCell>{a.SKU}</TableCell>
                                    <TableCell>{formatMoney(a.Price)}</TableCell>
                                    <GreenCell>
                                        <TableInput
                                            value={exists?.Qty || 0}
                                            onChange={(e) => updateAddons(a.PipedriveID, parseInt(e.target.value) || 0)}
                                        />
                                    </GreenCell>
                                    <TableCell>{total}</TableCell>
                                </AddonAlternateRow>
                            )
                        })
                    }
                    <TableRow>
                        <CellNoBorder>&nbsp;</CellNoBorder>
                    </TableRow>
                    <StyledTableRow>
                        <GreenCell>
                            <TableInput
                                value={formData.extraAddons1?.PipedriveID.toString()}
                                onChange={(e) => updateExtraAddon('extraAddons1', 'PipedriveID', parseInt(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput style={{width:"100%"}}
                                value={formData.extraAddons1.Description}
                                onChange={(e) => updateExtraAddon('extraAddons1', 'Description', e.target.value)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput style={{width:"100%"}}
                                value={formData.extraAddons1.SKU}
                                onChange={(e) => updateExtraAddon('extraAddons1', 'SKU', e.target.value)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput
                                value={formData.extraAddons1?.Price.toString()}
                                onChange={(e) => updateExtraAddon('extraAddons1', 'Price', parseFloat(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput
                                value={formData.extraAddons1?.Qty.toString()}
                                onChange={(e) => updateExtraAddon('extraAddons1', 'Qty', parseFloat(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <GreenCell>
                            {formatMoney(formData.extraAddons1.Qty * formData.extraAddons1.Price)}
                        </GreenCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <GreenCell>
                            <TableInput
                                value={formData.extraAddons2?.PipedriveID.toString()}
                                onChange={(e) => updateExtraAddon('extraAddons2', 'PipedriveID', parseInt(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput style={{width:"100%"}}
                                value={formData.extraAddons2.Description}
                                onChange={(e) => updateExtraAddon('extraAddons2', 'Description', e.target.value)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput style={{width:"100%"}}
                                value={formData.extraAddons2.SKU}
                                onChange={(e) => updateExtraAddon('extraAddons2', 'SKU', e.target.value)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput
                                value={formData.extraAddons2?.Price.toString()}
                                onChange={(e) => updateExtraAddon('extraAddons2', 'Price', parseFloat(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <GreenCell>
                            <TableInput
                                value={formData.extraAddons2?.Qty.toString()}
                                onChange={(e) => updateExtraAddon('extraAddons2', 'Qty', parseFloat(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <GreenCell>
                            {formatMoney(formData.extraAddons2.Qty * formData.extraAddons2.Price)}
                        </GreenCell>
                    </StyledTableRow>
                </TableBody>
            </Table>
        </div>
    )
}